// import React from 'react';
// import { Link } from 'react-router-dom';

// import Logo from '../../assets/img/logo/footer-logo.png';
// import footerBG from '../../assets/img/footer/footer-bg.jpg';

// const Footer = (props) => {
//   const { footerLogo, footerClass } = props;
//   return (
//     <footer>
//       <div
//         className={footerClass ? footerClass : 'footer__area footer__plr'}
//         style={{ backgroundImage: `url(${footerBG})` }}
//       >
//         <div className="container-fluid">
//           <div className="row">
//             <div
//               className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-7 mb-70 wow animate__fadeInUp"
//               data-wow-duration="1.1s"
//             >
//               <div className="footer__widget footer-col-1">
//                 <div className="footer__logo">
//                   <Link to="/">
//                     <img src={footerLogo ? footerLogo : Logo} alt="" />
//                   </Link>
//                 </div>
//                 <div className="footer__content">
//                   <div className="footer__text">
//                     <p>
//                       Our approach to itis unique around know work an we know
//                       doesn’t work verified factors in play.
//                     </p>
//                   </div>
//                   <div className="footer__number-wrapper d-flex align-items-center">
//                     <div className="footer__number-icon">
//                       <span>
//                         <i className="fal fa-phone-alt"></i>
//                       </span>
//                     </div>
//                     <div className="footer__number-info">
//                       <span>Have Any Questions?</span>
//                       <a href="tel:+230045647823">+230-045-647-823</a>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div
//               className="col-xxl-3 col-xl-2 col-lg-6 col-md-6 col-sm-5 mb-70 wow animate__fadeInUp"
//               data-wow-duration="1.1s"
//             >
//               <div className="footer__widget footer-col-2">
//                 <h4 className="footer__title">
//                   <Link to="/service">Service</Link>
//                 </h4>
//                 <div className="footer__menu-list">
//                   <ul>
//                     <li>
//                       <a href="#">Web Design</a>
//                     </li>
//                     <li>
//                       <a href="#">Development</a>
//                     </li>
//                     <li>
//                       <a href="#">WordPress</a>
//                     </li>
//                     <li>
//                       <a href="#">Online Marketing</a>
//                     </li>
//                     <li>
//                       <a href="#">Content</a>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//             <div
//               className="col-xxl-3 col-xl-2 col-lg-6 col-md-6 col-sm-5 mb-70 wow animate__fadeInUp"
//               data-wow-duration="1.1s"
//             >
//               <div className="footer__widget footer-col-3">
//                 <h4 className="footer__title">
//                   <a href="#">Support Link</a>
//                 </h4>
//                 <div className="footer__menu-list">
//                   <ul>
//                     <li>
//                       <a href="#">Web Design</a>
//                     </li>
//                     <li>
//                       <a href="#">Development</a>
//                     </li>
//                     <li>
//                       <a href="#">WordPress</a>
//                     </li>
//                     <li>
//                       <a href="#">Online Marketing</a>
//                     </li>
//                     <li>
//                       <a href="#">Content</a>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//             <div
//               className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-7 mb-70 wow animate__fadeInUp"
//               data-wow-duration="1.1s"
//             >
//               <div className="footer__widget footer-col-4">
//                 <h4 className="footer__title">
//                   <a href="#">Newslatter</a>
//                 </h4>
//                 <div className="footer__content">
//                   <p>
//                     Our approach to itis unique around know work an we know.
//                   </p>
//                 </div>
//                 <div className="footer__input">
//                   <form action="#">
//                     <input type="email" placeholder="Your email" />
//                     <button className="subscribe-btn">Subscribe </button>
//                   </form>
//                 </div>
//                 <div className="footer__social-box">
//                   <span>Social Media:</span>
//                   <a href="#">
//                     <i className="fab fa-facebook-f"></i>
//                   </a>
//                   <a href="#">
//                     <i className="fab fa-twitter"></i>
//                   </a>
//                   <a href="#">
//                     <i className="fab fa-google-plus-g"></i>
//                   </a>
//                   <a href="#">
//                     <i className="fab fa-pinterest-p"></i>
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="copyright__area copyright__plr black-bg-3">
//         <div className="container-fluid">
//           <div className="row align-items-center">
//             <div
//               className="col-md-6 wow animate__slideInUp"
//               data-wow-duration="1.1s"
//             >
//               <div className="copyright__text">
//                 <span>Copyright Sorex 2024, All Right Reserved</span>
//               </div>
//             </div>
//             <div
//               className="col-md-6 wow animate__fadeInUp"
//               data-wow-duration="1.1s"
//             >
//               <div className="copyright__item text-start text-md-end">
//                 <span>
//                   <a href="#">Home</a>
//                 </span>
//                 <span>
//                   <a href="#">Cases</a>
//                 </span>
//                 <span>
//                   <a href="#">About</a>
//                 </span>
//                 <span>
//                   <a href="#">Privacy & Policy</a>
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;
import React from "react";
import { Link } from "react-router-dom";

import Logo from "../../assets/img/prd/PRD-infotech_1 (2).png";
import footerBG from "../../assets/img/footer/footer-bg.jpg";

const Footer = (props) => {
  const { footerLogo, footerClass } = props;
  return (
    <footer>
      <div
        className={footerClass ? footerClass : "footer__area footer__plr"}
        style={{ backgroundImage: `url(${footerBG})` }}
      >
        <div className="container-fluid">
          <div className="row">
            {/* Company Info */}
            <div
              className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-7 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer__widget footer-col-1">
                <div className="footer__logo">
                  <Link to="/">
                    <img
                      src={footerLogo ? footerLogo : Logo}
                      alt="Company Logo"
                    />
                  </Link>
                </div>
                <div className="footer__content">
                  <div className="footer__text">
                    <p>
                      PRD Infotech is committed to delivering cutting-edge
                      software solutions that optimize business efficiency. From
                      ERP & CRM systems to custom software, we help businesses
                      thrive in the digital age.
                    </p>
                  </div>
                  <div className="footer__number-wrapper d-flex align-items-center">
                    <div className="footer__number-icon">
                      <span>
                        <i className="fal fa-phone-alt"></i>
                      </span>
                    </div>
                    <div className="footer__number-info">
                      <span>Have Any Questions?</span>
                      <a href="tel:+917376117171">+91 7376117171</a>
                    </div>
                  </div>
                  <div className="footer__email">
                    <span>Email Us:</span>
                    <a href="mailto:raaj@prdinfotech.com">
                      raaj@prdinfotech.com
                    </a>
                  </div>
                  <div className="footer__address">
                    <span>Our Location:</span>
                    <p>
                      Plot No.20, St. No. 4-B, Qutub Vihar, Phase-I, Jhankar
                      Road, Najafgarh, New Delhi-110071
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Services */}
            <div
              className="col-xxl-3 col-xl-2 col-lg-6 col-md-6 col-sm-5 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer__widget footer-col-2">
                <h4 className="footer__title">
                  <Link to="/services">Our Services</Link>
                </h4>
                <div className="footer__menu-list">
                  <ul>
                    <li>
                      <Link to="/services/erp-crm">ERP & CRM Solutions</Link>
                    </li>
                    <li>
                      <Link to="/services/mobile-app-development">
                        Mobile App Development
                      </Link>
                    </li>
                    <li>
                      <Link to="/services/cloud-solutions">
                        Cloud Solutions
                      </Link>
                    </li>
                    <li>
                      <Link to="/services/digital-transformation">
                        Digital Transformation
                      </Link>
                    </li>
                    <li>
                      <Link to="/services/it-consulting">IT Consulting</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div
              className="col-xxl-3 col-xl-2 col-lg-6 col-md-6 col-sm-5 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer__widget footer-col-3">
                <h4 className="footer__title">
                  <a href="#">Quick Links</a>
                </h4>
                <div className="footer__menu-list">
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/about">About Us</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact</Link>
                    </li>
                    <li>
                      <Link to="/faq">FAQs</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Newsletter */}
            <div
              className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-7 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer__widget footer-col-4">
                <h4 className="footer__title">
                  <a href="#">Stay Updated</a>
                </h4>
                <div className="footer__content">
                  <p>
                    Subscribe to our newsletter to get the latest industry
                    insights and technology updates.
                  </p>
                </div>
                <div className="footer__input">
                  <form action="#">
                    <input type="email" placeholder="Your email" />
                    <button className="subscribe-btn">Subscribe</button>
                  </form>
                </div>
                <div className="footer__social-box">
                  <span>Follow Us:</span>
                  <a href="#">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-instagram"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="copyright__area copyright__plr black-bg-3">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div
              className="col-md-6 wow animate__slideInUp"
              data-wow-duration="1.1s"
            >
              <div className="copyright__text">
                <span>
                  Copyright © 2025 PRD Infotech Pvt. Ltd. , All Rights Reserved.
                </span>
              </div>
            </div>
            <div
              className="col-md-6 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="copyright__item text-start text-md-end">
                <span>
                  <Link to="/">Home</Link>
                </span>
                <span>
                  <Link to="/services">Services</Link>
                </span>
                <span>
                  <Link to="/contact">Contact</Link>
                </span>
                <span>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
